var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useStepperContext } from './StepperContext';
import useWizard from './useWizard';
/**
 * @typedef {Object} Stepper
 * @property {function} setStepProps - Set stepProps.
 * @property {object} stepProps - This object is spread onto this steps stepper, like status and label.
 * @property {boolean} showStepper - Toggled by current active step.
 * @property {number} setShowStepper - The index of the current step in navigation order.
 * @property {array} steps - Array of all the connected steps.
 * @property {string|number} activeStep - The ID of the current active step.
 * @property {function} goTo - Go to step based on step ID.
 * @property {object} stepperProps - Spread over stepper to connect to parent Wizard.
 * @property {*} Step - Component that wraps your step UI to hide/show based on navigation.
 */
/**
 * Get stepper status and props.
 * @returns {Stepper} Stepper object.
 */
var useStepper = function () {
    var _a = useWizard(), steps = _a.steps, activeStep = _a.activeStep, goTo = _a.goTo;
    var _b = useStepperContext(), showStepper = _b.showStepper, setShowStepper = _b.setShowStepper, stepProps = _b.stepProps, setStepProps = _b.setStepProps;
    var onStepSelection = function (step) { return goTo(step.id); };
    var currentStep = { step: activeStep };
    var stepperProps = {
        currentStep: currentStep,
        onStepSelection: onStepSelection,
        steps: steps.map(function (step) { return (__assign({ status: step.state && step.state.status, id: step.pathname, name: step.pathname }, (stepProps &&
            stepProps[step.pathname]))); })
    };
    return {
        setStepProps: setStepProps,
        stepProps: stepProps,
        showStepper: showStepper,
        setShowStepper: setShowStepper,
        steps: steps,
        activeStep: activeStep,
        goTo: goTo,
        stepperProps: stepperProps
    };
};
export default useStepper;
